const e = "Konto", n = "Kontostand", t = "Kontobeschreibung", a = "Konto-ID", r = "Aufschläge", i = "Anpassungen", s = "Betrag", o = "und", u = "Anwenden", c = "Zurück", l = "Guthabenkonto", d = "Guthabenkonto-ID", g = "Gebucht", h = "Erfasst", p = "Kategorie", f = "Chargebacks", m = "Schließen", b = "Support kontaktieren", k = "Kontaktieren Sie den Support, um Hilfe zu erhalten.", A = "Kontaktieren Sie den Support, um Hilfe zu erhalten, und geben Sie den Fehlercode %{requestId} an.", z = "Kopiert", y = "Kopieren", S = "Korrekturen", T = "Währung", R = "Datum", w = "Datumsbereich", v = "Beschreibung", B = "OK", F = "Herunterladen", D = "Wird heruntergeladen", I = "E-Mail", G = "Entität wurde nicht gefunden", C = "Transaktion für den angegebenen Kontoinhaber nicht gefunden", P = "Gebühren", W = "Datei", E = "Filterleiste", N = "Von", K = "Vollständig", O = "Erfasste Geldmittel", x = "Zurück", M = "Zuschuss gewährt", L = "Rückzahlungen von Zuschüssen", Z = "Inhalt ausblenden", V = "ID", U = "Unvollständiges Feld", q = "In Bearbeitung", H = "Wird geladen", Y = "max", _ = "Min.", X = "Mobil", j = "Netto-Auszahlung", J = "Nächste Auszahlungen", Q = "Keine Daten", $ = "Keine negativen Zahlen erlaubt", ee = "Keine Auszahlungen gefunden", ne = "Keine Berichte gefunden", te = "Keine Transaktionen gefunden", ae = "Andere", re = "Paginierte Navigation", ie = "Teilweise", se = "Zahlungs-ID", oe = "Zahlungsart", ue = "Auszahlungsdetails", ce = "Auszahlungsinformationen werden täglich um Mitternacht (UTC-Zeit) generiert.", le = "Auszahlungen", de = "Ausstehend", ge = "Bitte versuchen Sie es später noch einmal.", he = "Bitte wenden Sie sich an den Support, wenn Sie Hilfe benötigen.", pe = "Wenden Sie sich an den Support", fe = "Referenz-ID", me = "Aktualisieren", be = "Rückerstattungen", ke = "Zahlung erstatten", Ae = "Wir konnten die Erstattung nicht bearbeiten. Versuchen Sie es in Kürze erneut.", ze = "Etwas ist schiefgelaufen.", ye = "Ihr Kunde erhält das Geld in maximal 40 Tagen. Wenn die Erstattung erfolgreich ist, wird in Ihrer Liste eine neue Erstattungstransaktion angezeigt.", Se = "Erstattung wurde gesendet!", Te = "Zu erstattender Betrag", Re = "Erstattungen können je nach Zahlungsmethode bis zu 40 Tage dauern. Gebühren sind enthalten.", we = "Rückerstattung (%{amount})", ve = "Grund für den Refund", Be = "Referenz", Fe = "Restbetrag", De = "Bericht", Ie = "Die Berichte werden täglich um Mitternacht (UTC-Zeit) generiert.", Ge = "Berichte", Ce = "Zurücksetzen", Pe = "Rückgängig gemacht", We = "Etwas ist schiefgelaufen.", Ee = "Es ist etwas schief gelaufen. Versuchen Sie, die Seite zu aktualisieren, oder schauen Sie später noch einmal vorbei.", Ne = "Status", Ke = "Strukturierte Liste", Oe = "Abzüge", xe = "Summe der Auszahlungen am selben Tag", Me = "Registerkarten", Le = "Der Fehlercode lautet %{requestId}", Ze = "Es sind keine Ergebnisse vorhanden.", Ve = "In der Anfrage fehlen Pflichtfelder oder sie enthält ungültige Daten.", Ue = "Es ist ein unerwarteter Fehler aufgetreten.", qe = "Das gewählte Guthabenkonto ist falsch.", He = "Zeitzone", Ye = "An", _e = "Gesamte Eingänge", Xe = "Gesamte Ausgänge", je = "Der An-Wert sollte gleich oder größer sein als der Von-Wert", Je = "Details zur Transaktion", Qe = "Transaktionen", $e = "Übersicht über Transaktionen", en = "Transaktionsart", nn = "Überweisungen", tn = "Versuchen Sie es mit einer anderen Suchanfrage oder setzen Sie Ihre Filter zurück und wir versuchen es erneut.", an = "Versuchen Sie, die Seite zu aktualisieren, oder schauen Sie später noch einmal vorbei.", rn = "Betrag", sn = "Typ", on = "Wert", un = "Die Auszahlungsübersicht konnte nicht geladen werden.", cn = "Die Berichtsübersicht konnte nicht geladen werden.", ln = "Die Transaktionsübersicht konnte nicht geladen werden.", dn = "Ihre Guthabenkonten konnten nicht geladen werden.", gn = "Ihre Auszahlungen konnten nicht geladen werden.", hn = "Ihre Berichte konnten nicht geladen werden.", pn = "Ihre Transaktionen konnten nicht geladen werden.", fn = {
  account: e,
  accountBalance: n,
  accountDescription: t,
  accountID: a,
  additions: r,
  adjustments: i,
  amount: s,
  and: o,
  apply: u,
  back: c,
  balanceAccount: l,
  balanceAccountId: d,
  Booked: g,
  "button.clearAll": "Alles löschen",
  "calendar.controls": "Steuerelemente für die Kalendernavigation",
  "calendar.nextMonth": "Nächster Monat",
  "calendar.previousMonth": "Vorheriger Monat",
  "calendar.timezone": "Die Zeitzone ist eingestellt auf: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Ihr Konto ist inaktiv",
  "capital.actionNeeded": "Maßnahmen erforderlich",
  "capital.bankAccountDetails": "Angaben zum Bankkonto",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Kontonummer",
  "capital.bankCountryOrRegion": "Land/Region",
  "capital.bankRoutingNumber": "Bankleitzahl",
  "capital.bankSortCode": "Bankleitzahl",
  "capital.businessFinancing": "Unternehmensfinanzierung",
  "capital.businessFinancingOffer": "Angebot zur Unternehmensfinanzierung",
  "capital.businessFinancingSummary": "Zusammenfassung der Unternehmensfinanzierung",
  "capital.closed": "Geschlossen",
  "capital.couldNotContinueWithTheOffer": "Wir konnten das Angebot nicht fortsetzen.",
  "capital.couldNotLoadFinancialOffers": "Wir konnten keine finanziellen Angebote laden.",
  "capital.dailyRepaymentRate": "Tägliche Rückzahlungsrate",
  "capital.daysAndDaysLeft": "%{days} Tage (%{daysLeft} Tage übrig)",
  "capital.expectedRepaymentPeriod": "Erwartete Rückzahlungsfrist",
  "capital.failed": "Fehlgeschlagen",
  "capital.fees": "Gebühren",
  "capital.fullyRepaid": "Vollständig zurückgezahlt",
  "capital.goToTermsAndConditions": "Zu den Allgemeinen Geschäftsbedingungen",
  "capital.grantID": "Zuschuss-ID",
  "capital.howMuchMoneyDoYouNeed": "Wie viel Geld benötigen Sie?",
  "capital.inProgress": "In Bearbeitung",
  "capital.legalSubtitleAU": "Adyen Capital wird von Adyen Australia Pty Limited bereitgestellt.",
  "capital.legalSubtitleEU": "Kredite werden von Adyen N.V. vergeben.",
  "capital.legalSubtitleGB": "Kredite werden von Adyen N.V., vertreten durch die Londoner Niederlassung, vergeben.",
  "capital.legalSubtitleUS": "Kredite werden von der Adyen N.V. San Francisco Branch vergeben und unterliegen der Kreditgenehmigung.",
  "capital.maximumRepaymentPeriod": "Maximale Rückzahlungsdauer",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Mindesttilgung alle %{days} Tage, um die Finanzierung rechtzeitig zurückzuzahlen",
  "capital.needSomeExtraMoney": "Brauchen Sie zusätzliches Geld?",
  "capital.offerLegalNoticeDescriptionUS": "Wenn Ihr Antrag auf einen Geschäftskredit abgelehnt wird, haben Sie das Recht auf eine schriftliche Begründung der spezifischen Gründe für die Ablehnung. Um die Erklärung zu erhalten, wenden Sie sich bitte innerhalb von 60 Tagen nach Bekanntgabe unserer Entscheidung per E-Mail unter %{email} an das Credit Support Team von Adyen. Wir werden Ihnen innerhalb von 30 Tagen nach Eingang Ihres Antrags eine schriftliche Begründung für die Ablehnung zusenden. %{break} Der Federal Equal Credit Opportunity Act verbietet es Kreditgebern, Kreditantragsteller aufgrund von Ethnie, Hautfarbe, Religion, nationaler Herkunft, Geschlecht, Familienstand, Alter (sofern der Antragsteller geschäftsfähig ist, um einen verbindlichen Vertrag abzuschließen), weil das Einkommen des Antragstellers ganz oder teilweise aus einem öffentlichen Hilfsprogramm stammt oder weil der Antragsteller in gutem Glauben ein Recht gemäß dem Consumer Credit Protection Act ausgeübt hat, zu diskriminieren. Die Bundesbehörde, die die Einhaltung dieses Gesetzes in Bezug auf diesen Gläubiger verwaltet, ist das Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Gläubiger: Adyen N.V. – Niederlassung San Francisco %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 Monat",
  "capital.pending": "Ausstehend",
  "capital.primaryAccount": "Hauptkonto",
  "capital.remaining": "Verbleibend",
  "capital.remainingAmount": "Restbetrag",
  "capital.remainingFees": "Verbleibende Gebühren",
  "capital.repaid": "Zurückgezahlt",
  "capital.repaidAmount": "Zurückgezahlter Betrag",
  "capital.repaidFees": "Zurückgezahlte Gebühren",
  "capital.repaymentBalanceInfo": "Ihr aktueller Restbetrag, einschließlich Gebühren, beträgt %{amount}.",
  "capital.repaymentThreshold": "Tilgungsschwelle",
  "capital.requestedFunds": "Angeforderte Geldmittel",
  "capital.requestFunds": "Geldmittel anfordern",
  "capital.requesting": "Anfordern",
  "capital.reviewOffer": "Angebot prüfen",
  "capital.revoked": "Widerrufen",
  "capital.seeNewOffer": "Neues Angebot sehen",
  "capital.seeOptions": "Optionen anzeigen",
  "capital.sendRepayment": "Rückzahlung senden",
  "capital.sendRepaymentNotice": "Es kann 2 bis 3 Werktage dauern, bis die zusätzliche Überweisung für die Rückzahlung Ihres Kredits auf Ihrem Kreditkonto erscheint.",
  "capital.sendRepaymentSubtitle": "Überweisen Sie Geld auf dieses Bankkonto, um einen Teil Ihres Kredits oder den gesamten Betrag zurückzuzahlen.",
  "capital.signTermsAndConditionsToReceiveFunds": "Unterzeichnen Sie die Allgemeinen Geschäftsbedingungen, um Ihr Geld zu erhalten.",
  "capital.signTheTermsToReceiveYourFunds": "Unterzeichnen Sie die Bedingungen, um Ihre Gelder zu erhalten",
  "capital.termEnds": "Laufzeitende: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Es ist kein Hauptkonto konfiguriert",
  "capital.thisOfferExpiresOn": "Dieses Angebot läuft am %{date} ab.",
  "capital.totalFees": "Gesamtgebühren",
  "capital.totalRepaymentAmount": "Gesamter Rückzahlungsbetrag",
  "capital.unsupportedRegionDescription": "Unternehmensfinanzierung ist in Ihrer Region noch nicht verfügbar, aber schauen Sie hier wieder nach, um ein Angebot zu erhalten.",
  "capital.unsupportedRegionTitle": "Bleiben Sie dran!",
  "capital.weCouldNotContinueWithTheOffer": "Wir konnten das Angebot nicht fortsetzen.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Wir konnten das Angebot nicht fortsetzen. Kontaktieren Sie den Support, um Hilfe zu erhalten.",
  "capital.weCouldNotLoadFinancialOffers": "Wir konnten keine finanziellen Angebote laden.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Wir konnten diese Anfrage nicht bearbeiten. Versuchen Sie es mit einem neuen Angebot erneut.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Wir haben Ihre Anfrage erhalten und bearbeiten sie gerade. Schauen Sie bald wieder vorbei, um die nächsten Schritte zu erfahren.",
  "capital.writtenOff": "Abgeschrieben",
  "capital.xDays": "%{days} Tage",
  "capital.xMonths": "%{months} Monate",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Sie haben die Geldmittel angenommen, aber dann zurückgegeben",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Sie haben diese Geldmittel angenommen, aber nicht zurückgezahlt",
  "capital.youAreRequestingFundingOf": "Sie beantragen die Finanzierung von",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Sie wurden für Unternehmensfinanzierung vorqualifiziert",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " bis zu %{amount}.",
  "capital.yourRequestedFundsWere": "Ihre angeforderten Geldmittel sind: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Sie sollten das Geld innerhalb eines Werktages erhalten",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Sie müssen mindestens alle %{days} Tage einen Mindestbetrag von %{amount} zurückzahlen, um den vollständigen Betrag bis zum %{date} zu begleichen.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Sie werden sich bald für ein finanzielles Angebot qualifizieren!",
  capture: h,
  category: p,
  chargeback: f,
  closeIconLabel: m,
  contactSupport: b,
  contactSupportForHelp: k,
  contactSupportForHelpAndShareErrorCode: A,
  copied: z,
  copy: y,
  correction: S,
  currency: T,
  date: R,
  dateRange: w,
  default: "Standard",
  description: v,
  dismiss: B,
  download: F,
  downloading: D,
  email: I,
  entityWasNotFound: G,
  entityWasNotFoundDetail: C,
  "error.pleaseTryAgainLater": "Bitte versuchen Sie es später erneut.",
  "error.somethingWentWrongWithDownload": "Beim Herunterladen ist ein Fehler aufgetreten",
  "expandableCard.collapse": "Zuklappen",
  "expandableCard.expand": "Aufklappen",
  export: "Exportieren",
  fee: P,
  file: W,
  "filter.date.since": "Seit %{date}",
  "filter.date.until": "Bis %{date}",
  filterBar: E,
  "filterPlaceholder.category": "Typ",
  "filterPlaceholder.currency": "Währung",
  "filterPlaceholder.status": "Status",
  from: N,
  full: K,
  fundsCaptured: O,
  goBack: x,
  grantIssued: M,
  grantRepayment: L,
  hideContent: Z,
  id: V,
  incompleteField: U,
  inProgress: q,
  loading: H,
  max: Y,
  min: _,
  mobile: X,
  netPayout: j,
  nextPayouts: J,
  noData: Q,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: ne,
  noTransactionsFound: te,
  other: ae,
  paginatedNavigation: re,
  "pagination.nextPage": "Nächste Seite",
  "pagination.previousPage": "Vorherige Seite",
  "pagination.showing": "Wird angezeigt",
  partial: ie,
  paymentId: se,
  paymentMethod: oe,
  payoutDetails: ue,
  payoutsNotice: ce,
  payoutsTitle: le,
  Pending: de,
  pleaseComeBackLater: ge,
  pleaseReachOutToSupportForAssistance: he,
  "rangePreset.custom": "Benutzerdefiniert",
  "rangePreset.last30Days": "Letzte 30 Tage",
  "rangePreset.last7Days": "Letzte 7 Tage",
  "rangePreset.lastMonth": "Letzter Monat",
  "rangePreset.lastWeek": "Letzte Woche",
  "rangePreset.thisMonth": "Diesen Monat",
  "rangePreset.thisWeek": "Diese Woche",
  "rangePreset.yearToDate": "Laufendes Jahr",
  reachOutToSupport: pe,
  referenceID: fe,
  refresh: me,
  refund: be,
  "refund.amountAlreadyRefunded": "Sie haben bereits %{amount} erstattet",
  "refund.amountFailed": "Die Erstattung für %{amount} ist fehlgeschlagen. Eine Rückerstattung dieses Betrags ist derzeit nicht möglich. Bitte kontaktieren Sie den Support.",
  "refund.amountInProgress": "Die Teilrückerstattung von %{amount} wird bearbeitet.",
  "refund.fee": "Gebühr",
  "refund.fullAmountFailed": "Es ist nicht möglich, diese Zahlung zu erstatten. Bitte kontaktieren Sie den Support.",
  "refund.fullAmountRefunded": "Der volle Betrag wurde dem Kunden erstattet.",
  "refund.goToPayment": "Zur Zahlung",
  "refund.maximumRefundable": "Sie können maximal %{amount} erstatten.",
  "refund.onlyRefundable": "Sie können nur %{amount} erstatten.",
  "refund.originalAmount": "Ursprünglicher Betrag",
  "refund.originalPayment": "Ursprüngliche Zahlung",
  "refund.paymentPspReference": "PSP-Referenz der Zahlung",
  "refund.pspReference": "PSP-Referenz",
  "refund.refundFee": "Erstattungsgebühr",
  "refund.refundPspReference": "PSP-Referenz für Erstattungen",
  "refund.returnToRefund": "Zurück zur Erstattung",
  "refund.theRefundIsBeingProcessed": "Die Erstattung wird bearbeitet.",
  refundAction: ke,
  refundActionErrorSubtitle: Ae,
  refundActionErrorTitle: ze,
  refundActionSuccessSubtitle: ye,
  refundActionSuccessTitle: Se,
  refundAmount: Te,
  "refundAmount.excess": "Sie dürfen den verfügbaren Betrag von %{amount} nicht überschreiten",
  "refundAmount.required": "Geben Sie einen Erstattungsbetrag ein",
  "refunded.full": "Vollständig erstattet",
  "refunded.partial": "Teilweise erstattet",
  refundNotice: Re,
  refundPayment: we,
  refundReason: ve,
  "refundReason.duplicate": "Duplizieren",
  "refundReason.fraudulent": "Betrügerisch",
  "refundReason.issue_with_item_sold": "Problem mit verkauftem Artikel",
  "refundReason.other": "Andere",
  "refundReason.requested_by_customer": "Vom Kunden angefordert",
  refundReference: Be,
  "refundReference.placeholder": "Referenz hier eingeben",
  remainingAmount: Fe,
  report: De,
  "reportsError.tooManyDownloads": "Wir konnten nicht alle Dateien herunterladen. Bitte versuchen Sie es später erneut.",
  reportsNotice: Ie,
  reportsTitle: Ge,
  "reportType.payout": "Auszahlung",
  reset: Ce,
  Reversed: Pe,
  "select.filter.placeholder": "Platzhalter",
  "select.noOptionsFound": "Keine Optionen für diese Suche vorhanden",
  somethingWentWrong: We,
  somethingWentWrongTryRefreshingOrComeBackLater: Ee,
  status: Ne,
  structuredList: Ke,
  subtractions: Oe,
  sumOfSameDayPayouts: xe,
  tabs: Me,
  theErrorCodeIs: Le,
  thereAreNoResults: Ze,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: Ve,
  thereWasAnUnexpectedError: Ue,
  theSelectedBalanceAccountIsIncorrect: qe,
  timezone: He,
  to: Ye,
  "tooltip.ATM": "Geld, das an einem Geldautomaten abgehoben wird",
  "tooltip.Capital": "Geld aus einem eingehenden Darlehenszuschuss oder einer ausgehenden Darlehensrückzahlung",
  "tooltip.Chargeback": "Geld wurde einem Kunden nach einer angefochtenen Transaktion zurückerstattet",
  "tooltip.Correction": "Anpassungen Ihrer Gelder, einschließlich Transaktionsstornierungen und Einzahlungskorrekturen",
  "tooltip.Fee": "Transaktionskosten und Gebühren für Zahlungsmethoden",
  "tooltip.Other": "Transaktionen, die nicht in eine andere Kategorie fallen, in der Regel eine Anpassung",
  "tooltip.Payment": "Geld, das Sie durch eine Verkaufstransaktion auf Ihrem Konto erhalten haben",
  "tooltip.Refund": "Geld, das von einer erstatteten Transaktion an einen Kunden zurückgeschickt wurde",
  "tooltip.totalIncoming": "Alle auf Ihrem Konto eingegangenen Gelder basierend auf den ausgewählten Filtern",
  "tooltip.totalOutgoing": "Alle Gebühren, Erstattungen, Auszahlungen und andere Abbuchungen basierend auf den ausgewählten Filtern",
  "tooltip.Transfer": "Geld wurde zwischen Ihrem Konto und einem anderen Konto transferiert",
  totalIncoming: _e,
  totalOutgoing: Xe,
  toValueShouldBeGreaterThanTheFromValue: je,
  transactionDetails: Je,
  transactions: Qe,
  transactionsOverviewTitle: $e,
  transactionType: en,
  transfer: nn,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: tn,
  tryRefreshingThePageOrComeBackLater: an,
  txAmount: rn,
  "txType.ATM": "Geldautomat",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Korrektur",
  "txType.Fee": "Gebühr",
  "txType.Other": "Andere",
  "txType.Payment": "Zahlung",
  "txType.Refund": "Rückerstattung",
  "txType.Transfer": "Überweisung",
  type: sn,
  value: on,
  weCouldNotLoadThePayoutsOverview: un,
  weCouldNotLoadTheReportsOverview: cn,
  weCouldNotLoadTheTransactionsOverview: ln,
  weCouldNotLoadYourBalanceAccounts: dn,
  weCouldNotLoadYourPayouts: gn,
  weCouldNotLoadYourReports: hn,
  weCouldNotLoadYourTransactions: pn
};
export {
  g as Booked,
  de as Pending,
  Pe as Reversed,
  e as account,
  n as accountBalance,
  t as accountDescription,
  a as accountID,
  r as additions,
  i as adjustments,
  s as amount,
  o as and,
  u as apply,
  c as back,
  l as balanceAccount,
  d as balanceAccountId,
  h as capture,
  p as category,
  f as chargeback,
  m as closeIconLabel,
  b as contactSupport,
  k as contactSupportForHelp,
  A as contactSupportForHelpAndShareErrorCode,
  z as copied,
  y as copy,
  S as correction,
  T as currency,
  R as date,
  w as dateRange,
  fn as default,
  v as description,
  B as dismiss,
  F as download,
  D as downloading,
  I as email,
  G as entityWasNotFound,
  C as entityWasNotFoundDetail,
  P as fee,
  W as file,
  E as filterBar,
  N as from,
  K as full,
  O as fundsCaptured,
  x as goBack,
  M as grantIssued,
  L as grantRepayment,
  Z as hideContent,
  V as id,
  q as inProgress,
  U as incompleteField,
  H as loading,
  Y as max,
  _ as min,
  X as mobile,
  j as netPayout,
  J as nextPayouts,
  Q as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  ne as noReportsFound,
  te as noTransactionsFound,
  ae as other,
  re as paginatedNavigation,
  ie as partial,
  se as paymentId,
  oe as paymentMethod,
  ue as payoutDetails,
  ce as payoutsNotice,
  le as payoutsTitle,
  ge as pleaseComeBackLater,
  he as pleaseReachOutToSupportForAssistance,
  pe as reachOutToSupport,
  fe as referenceID,
  me as refresh,
  be as refund,
  ke as refundAction,
  Ae as refundActionErrorSubtitle,
  ze as refundActionErrorTitle,
  ye as refundActionSuccessSubtitle,
  Se as refundActionSuccessTitle,
  Te as refundAmount,
  Re as refundNotice,
  we as refundPayment,
  ve as refundReason,
  Be as refundReference,
  Fe as remainingAmount,
  De as report,
  Ie as reportsNotice,
  Ge as reportsTitle,
  Ce as reset,
  We as somethingWentWrong,
  Ee as somethingWentWrongTryRefreshingOrComeBackLater,
  Ne as status,
  Ke as structuredList,
  Oe as subtractions,
  xe as sumOfSameDayPayouts,
  Me as tabs,
  Le as theErrorCodeIs,
  Ve as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  qe as theSelectedBalanceAccountIsIncorrect,
  Ze as thereAreNoResults,
  Ue as thereWasAnUnexpectedError,
  He as timezone,
  Ye as to,
  je as toValueShouldBeGreaterThanTheFromValue,
  _e as totalIncoming,
  Xe as totalOutgoing,
  Je as transactionDetails,
  en as transactionType,
  Qe as transactions,
  $e as transactionsOverviewTitle,
  nn as transfer,
  tn as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  an as tryRefreshingThePageOrComeBackLater,
  rn as txAmount,
  sn as type,
  on as value,
  un as weCouldNotLoadThePayoutsOverview,
  cn as weCouldNotLoadTheReportsOverview,
  ln as weCouldNotLoadTheTransactionsOverview,
  dn as weCouldNotLoadYourBalanceAccounts,
  gn as weCouldNotLoadYourPayouts,
  hn as weCouldNotLoadYourReports,
  pn as weCouldNotLoadYourTransactions
};
